module.exports = __webpack_public_path__ + "static/media/1.question.85477218.mp4";